import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { OrderListDto } from './OrderListDto'
/**
* Class PageOfOrderListDto
*  Результат постраничного запроса
*/
export class PageOfOrderListDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [OrderListDto, () => undefined]
  })
  items?: Array<OrderListDto>
}
